import { c as _c } from "react/compiler-runtime";
import { cn } from "@domainstack/ui/utils";

// Tailwind requires static class names; map numeric props to explicit classes
const BASE_CLASS_MAP: Record<1 | 2 | 3, string> = {
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3"
};
const DESKTOP_CLASS_MAP: Record<1 | 2 | 3, string> = {
  1: "sm:grid-cols-1",
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-3"
};
export function KeyValueGrid(t0) {
  const $ = _c(7);
  const {
    children,
    className,
    colsMobile: t1,
    colsDesktop
  } = t0;
  const colsMobile = t1 === undefined ? 1 : t1;
  const mobileClass = BASE_CLASS_MAP[colsMobile];
  const desktopClass = colsDesktop ? DESKTOP_CLASS_MAP[colsDesktop] : undefined;
  let t2;
  if ($[0] !== className || $[1] !== desktopClass || $[2] !== mobileClass) {
    t2 = cn("grid gap-2", mobileClass, desktopClass, className);
    $[0] = className;
    $[1] = desktopClass;
    $[2] = mobileClass;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}